import _ from 'lodash';

export const USER_SETTINGS = 'user_settings';
export const USER_PROFILE = 'user_profile';
export const USER_EDIT_PROFILE = 'user_edit_profile'; // no route
export const FOLLOWERS = 'followers';
export const FOLLOWING = 'following';
export const NOTIFICATIONS = 'notifications';
export const SEARCH_RESULTS = 'search_results';
export const POST_PAGE = 'post_page';
export const POST_EDIT_PAGE = 'post_edit_page';
export const COMMENT_EDIT_PAGE = 'comment_edit_page';
export const FEED_PAGE = 'feed_page';
export const CATEGORIES_PAGE = 'categories_page';
export const CREATE_POST = 'create_post';
export const MEMBERS_PAGE = 'members_page';

export const routeMap = {
  [USER_SETTINGS]: /^\/profiles\/.*?\/settings/,
  [USER_PROFILE]: /^\/profiles\/[0-9a-zA-Z-_]+\/?$/,
  [FOLLOWERS]: /^\/profiles\/[0-9a-zA-Z-_]+\/followers\/?$/,
  [FOLLOWING]: /^\/profiles\/[0-9a-zA-Z-_]+\/following\/?$/,
  [NOTIFICATIONS]: /^\/notifications\/?$/,
  [SEARCH_RESULTS]: /^\/search(\/(posts|members))?\/?$/,
  [MEMBERS_PAGE]: /^\/members\/?$/,
  [CREATE_POST]: /^\/[0-9a-zA-Z-_]+\/create-post\/?/,
  [COMMENT_EDIT_PAGE]: /^\/[0-9a-zA-Z-_]+\/([0-9a-zA-Z-_]+)\/edit-comment\/[0-9a-zA-Z-_]+\/?/,
  [POST_EDIT_PAGE]: /^\/[0-9a-zA-Z-_]+\/([0-9a-zA-Z-_]+)\/edit\/?/,
  [POST_PAGE]: /^\/[0-9a-zA-Z-_]+\/([0-9a-zA-Z-_]+)\/?/,
  [FEED_PAGE]: /^\/([0-9a-zA-Z-_]+)\/?/,
  [CATEGORIES_PAGE]: /^\/$/,
};

const testRoute = (map, location) => _.findKey(routeMap, regex => regex.test(location));

const detectRoute = location => {
  const pathname = typeof location === 'object' ? location.pathname : location;
  return testRoute(routeMap, pathname);
};

export default detectRoute;



// WEBPACK FOOTER //
// ./app/services/detect-route.js